import { render, staticRenderFns } from "./Gratificacion.vue?vue&type=template&id=034f1298"
import script from "./Gratificacion.vue?vue&type=script&lang=ts"
export * from "./Gratificacion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports